import React from 'react';
import { observer } from 'mobx-react-lite';
import globalUserProfile from '../../../../stores/global-user-profile';
import { StudentCalendar } from '../../../../component/calendar/student-calendar/student-calendar';

export const MyLecturesCalendarStudent = observer(() => {
  if (!globalUserProfile.userProfile?.userWithRole?.id) {
    return <div>Loading user profile...</div>;
  }

  return (
    <StudentCalendar
      studentId={globalUserProfile.userProfile.userWithRole.id}
    />
  );
});
